module.exports = __webpack_public_path__ + "static/img/driver1.cd846f91.png";